import * as React from "react";

interface Props {
    color: string;
}

const CircleInfo = (props: Props): JSX.Element => {
    return (
        <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_4803_88861)">
                <rect x="3" y="1" width="30" height="30" rx="15" fill={props.color} />
                <circle cx="18" cy="16" r="7.22656" stroke="white" strokeWidth="1.17187" />
                <path
                    d="M18.7812 12.0937C18.7812 12.5252 18.4315 12.875 18 12.875C17.5685 12.875 17.2188 12.5252 17.2188 12.0937C17.2188 11.6623 17.5685 11.3125 18 11.3125C18.4315 11.3125 18.7812 11.6623 18.7812 12.0937Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 14.4375C18.4315 14.4375 18.7812 14.7873 18.7812 15.2187V19.9062C18.7812 20.3377 18.4315 20.6875 18 20.6875C17.5685 20.6875 17.2188 20.3377 17.2188 19.9062V15.2187C17.2188 14.7873 17.5685 14.4375 18 14.4375Z"
                    fill="white"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_4803_88861"
                    x="0.75"
                    y="0.25"
                    width="34.5"
                    height="34.5"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1.5" />
                    <feGaussianBlur stdDeviation="1.125" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4803_88861" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4803_88861" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};

export default CircleInfo;
